/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    PAYMENTS_title: "Paiements",
    PAYMENTS_label: "paiement",
    PAYMENTS_plural_label: "paiements",

    PAYMENTS_columnTotal: "Total",
    PAYMENTS_columnFrequency: "Fréquence",
    PAYMENTS_columnNumber: "Numéro de facture",
    PAYMENTS_columnCustomerName: "Nom du client",
    PAYMENTS_columnCustomerEmail: "E-mail du client",
    PAYMENTS_columnDueDate: "Date d'échéance",
    PAYMENTS_columnCreatedAt: "Date de création",

    PAYMENTS_frequencyMonthly: "Mensuel",
    PAYMENTS_frequencyYearly: "Annuel",

    PAYMENTS_statusSucceeded: "Réussi",
    PAYMENTS_statusProcessing: "En cours",
    PAYMENTS_statusIncomplete: "Incomplet",
    PAYMENTS_statusCanceled: "Annulé",

    PAYMENTS_filterName: "Nom du client",
    PAYMENTS_filterNamePlaceholder: "Filtrer par nom du client",
    PAYMENTS_filterStatus: "Statut",
    PAYMENTS_filterStatusPlaceholder: "Filtrer par statut",

    PAYMENTS_statusPaid: "Payée",
    PAYMENTS_statusOpen: "En attente",
    PAYMENTS_statusUncollectible: "Non réglée",
    PAYMENTS_statusVoid: "Annulée",
    PAYMENTS_statusRejected: "Rejetée",

    PAYMENTS_noCustomerLinked: "Aucun client lié à ce paiement.",

    PAYMENTS_splashScreenTitle: "Aucune facture",
    PAYMENTS_splashScreenDescription: "Les factures de vos clients apparaîtront ici."
};
